import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { PortfolioPage } from './pages/PortfolioPage';
import { PortfolioRedirect } from './pages/PortfolioRedirect';
import { HowWeInvestPage } from './pages/HowWeInvestPage';
import { HowWeHelpPage } from './pages/HowWeHelpPage';
import { TeamPage } from './pages/TeamPage';
import { TeamMemberPage } from './pages/TeamMemberPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { InsightsPage } from './pages/InsightsPage';
import { ContactPage } from './pages/ContactPage';
import { ThemeProvider } from './contexts/ThemeContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="flex flex-col min-h-screen bg-white text-[#070707] transition-colors" data-id="element-2">
          <Navbar data-id="element-3" />
          <main className="flex-grow" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
              <Route path="/home" element={<Navigate to="/" replace data-id="element-9" />} data-id="element-8" />
              <Route path="/companies" element={<PortfolioPage data-id="element-11" />} data-id="element-10" />
              <Route path="/portfolio" element={<Navigate to="/companies" replace data-id="element-13" />} data-id="element-12" />
              <Route path="/portfolio/:slug" element={<PortfolioRedirect data-id="element-15" />} data-id="element-14" />
              <Route path="/how-we-invest" element={<HowWeInvestPage data-id="element-17" />} data-id="element-16" />
              <Route path="/how-we-help" element={<HowWeHelpPage data-id="element-19" />} data-id="element-18" />
              <Route path="/team" element={<TeamPage data-id="element-21" />} data-id="element-20" />
              <Route path="/team/:slug" element={<TeamMemberPage data-id="element-23" />} data-id="element-22" />
              <Route path="/blog" element={<BlogPage data-id="element-25" />} data-id="element-24" />
              <Route path="/blog/:slug" element={<BlogPostPage data-id="element-27" />} data-id="element-26" />
              <Route path="/insights" element={<InsightsPage data-id="element-29" />} data-id="element-28" />
              <Route path="/contact" element={<ContactPage data-id="element-31" />} data-id="element-30" />
              <Route path="/contactus" element={<Navigate to="/contact" replace data-id="element-33" />} data-id="element-32" />
            </Routes>
          </main>
          <Footer data-id="element-34" />
        </div>
      </BrowserRouter>
    </ThemeProvider>;
}